import styled from "styled-components";

export const SubmitReqPreToggleBtnStyled = styled.div`
  font-weight: bold;
  font-size: 1.2em;
  position: relative;

  display: flex;
  align-items: center;

  border-radius: 12px;
  border: solid 1px #ffbf1d;
  overflow: hidden;

  & > button {
    flex-basis: 50%;
    text-align: center;
    padding: 10px 0;
    z-index: 1;
    font-weight: bold;
  }

  .active {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 50%;
    height: 100%;
    box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.4);
    background-color: #ffbf1d;
    z-index: 0;
    border-radius: 12px;

    transition: 0.5s;

    left: ${({ submitType }) => {
      return submitType === "instant" ? "50%" : "0";
    }};
  }
`;
